import React, { useEffect, useState } from "react";
// import "./Destinations.css"; // Optional: use this for shared styles

import Nav from "./Nav";
import Footer from "./Footer";
import { NavLink, useNavigate } from "react-router-dom";
// import wlogo from "../../../assets/Images/TCL_logo (1).png";
import wlogo from "../../../src/assets/Images/TCL_logo (1).png";
import wha from "../../../src/assets/Images/wha.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBars } from "@fortawesome/free-solid-svg-icons";
import Seo from "../Seo/Seo";
import { useSeoMeta } from "../Seo/useSeoMeta";
import { SITE_NAME } from "../Seo/seoConfig";


const DESTINATION_PAGE_BASE = process.env.REACT_APP_API_URL.replace(/api\/?$/, "");

const AllDestinations = () => {
  const centralizedSeo = useSeoMeta();
  const [destinations, setDestinations] = useState([]);
  const [isToggled, setIsToggled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}AllDestination`
        );
        const data = await response.json();
        if (data.status === "true") {
          setDestinations(data.data);
        } else {
          console.error("Error fetching data:", data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const closeNavbar = () => {
    setIsToggled(false);
  };

  const handleLogOut = () => {
    alert("You are Logging out...");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setIsToggled(false);
    setTimeout(() => {
      navigate("/");
    }, 1500);
  };

  return (
    <>
      <Seo
        title={`All Ladakh Destinations Travel Guide | ${SITE_NAME}`}
        description={`Explore the best places to visit in Ladakh with ${SITE_NAME} - from Pangong Lake to Nubra Valley, find travel guides for every Ladakh destination.`}
        type="website"
        centralizedSeo={centralizedSeo}
      />
      {/* <Nav /> */}
      <div className="fluid-container" >


<Nav/>

        





      </div>

      <div className="container" style={{marginTop: "5rem"}}>
        <h1
          className="text-center mb-3"
          style={{
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "42px",
            textTransform: "capitalize",
          
          }}
        >
          Explore All Destinations
        </h1>

        {/* <div className="row g-4">
  {destinations.map((destination) => (
    <div key={destination.id} className="col-md-6 col-lg-4">
      <div className="p-2 h-100"> 
        <div
          className="card h-100"
          style={{
            border: "1px solid #ddd",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: "15px",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.02)";
            e.currentTarget.style.boxShadow =
              "0 6px 20px rgba(0, 0, 0, 0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px rgba(0, 0, 0, 0.1)";
          }}
        >
          <img
            src={destination.Image}
            alt={destination.Name}
            className="card-img-top"
            style={{
              height: "250px",
              objectFit: "cover",
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
            }}
          />
          <div className="card-body d-flex flex-column p-3">
            <h5 className="card-title fw-bold text-dark">
              {destination.Name}
            </h5>
            <div
              className="card-text text-muted"
              style={{ fontSize: "0.95rem" }}
              dangerouslySetInnerHTML={{ __html: destination.Details }}
            />
          </div>
        </div>
      </div>
    </div>
  ))}
</div> */}

        <div className="row g-4">
          {destinations.map((destination) => (
            <div key={destination.id} className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
              <div className="mb-4"> {/* Bottom margin for vertical spacing */}
                <a
                  href={destination.slug ? `${DESTINATION_PAGE_BASE}destination/${destination.slug}` : undefined}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit", display: "block", cursor: destination.slug ? "pointer" : "default" }}
                >
                <div
                  className="card h-100"
                  style={{
                    border: "1px solid #ddd",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "15px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    margin: "8px", // Additional margin for spacing between cards
                  }}
                // onMouseEnter={(e) => {
                //   e.currentTarget.style.transform = "scale(1.02)";
                //   e.currentTarget.style.boxShadow =
                //     "0 6px 20px rgba(0, 0, 0, 0.15)";
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.style.transform = "scale(1)";
                //   e.currentTarget.style.boxShadow =
                //     "0 4px 12px rgba(0, 0, 0, 0.1)";
                // }}
                >
                  <img
                    src={destination.Image}
                    alt={destination.Name}
                    className="card-img-top"
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    }}
                  />
                  <div className="card-body d-flex flex-column p-3">
                    <h2 className="card-title fw-bold text-dark mb-2" style={{ fontSize: '17px' }}>
                      {destination.Name}
                    </h2>
                    <div
                      className="card-text text-muted flex-grow-1"
                      style={{ fontSize: "0.95rem", lineHeight: "1.5" }}
                      dangerouslySetInnerHTML={{ __html: destination.Details }}
                    />
                  </div>
                </div>
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
      <Footer />
    </>
  );
};

export default AllDestinations;
